// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_hir","cls2":"Comments-cls2_gI8 Comments-cls1_hir"};